import { render, staticRenderFns } from "./sentIcon.vue?vue&type=template&id=e4eafd9c&"
import script from "./sentIcon.vue?vue&type=script&lang=js&"
export * from "./sentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports